export enum QueryKeys {
    ADMIN_USERS = 'admin-users',
    USERS = 'users',
    LANGUAGES = 'languages',
    CATEGORIES = 'categories',
    WIDGETS_TYPES = 'widget_types',
    TEMPLATES = 'templates',
    PAGES = 'pages',
    SETTINGS = 'settings',
    MONETIZATION_STRATEGY = 'monetization-strategy',

    // Plan Management
    PLANS = 'plans',
    PLAN_SETS = 'plan-sets',

    MEDIAS = 'medias',
    MOVIE = 'movie',
    SERIES = 'series',
    EBOOK = 'ebook',
    INTERACTIVITY = 'interactivity',
    GAME = 'GAME',
    LINEAR_MEDIA = 'linear-media',
    EBOOK_META = 'ebook-meta',
    EPISODES = 'episodes',
    EPISODE_DETAIL = 'episode-detail',
    SERIES_META = 'series-meta',
    SERIES_EPISODE = 'series-episode',
    AUDIO = 'audio',
    TRAY = 'tray',
    DECK = 'deck',
    TRAY_OPTIONS = 'tray-options',
    CHANNEL_OPTIONS = 'channel-options',
    POPULAR_SEARCH = 'popular-search',
    SKILLS = 'skills',
    FIRST_HIT = 'first-hit',
    COMMON_SERACH = 'common-search',
    CHANNEL = 'channel',
    SITE_SETTINGS = 'site-settings',
    SITE_CONSTANTS = 'site-constants',
    ROLES = 'roles',
    PERMISSIONS = 'permissions',
    MENUS = 'menus',
    UTILITY = 'utility',
    BUILD_VERSION = 'buildVersion',
    CACHE_PURGE = 'cachePurge',
    CATEGORY = 'category',
    CATEGORY_CONTENT = 'category-content',
    CATEGORY_CONFIG = 'category-config',
    CATEGORY_PARENT = 'category-parent',
    COURSES = 'courses',
    EVENTS = 'events',
    META_UPDATE = 'meta-update',
    MENU_LIST = 'menu',
    PLATFORM = 'platform',
    CLIENT = 'client',
    SMS = 'sms',
    TEMPLATE = "template",
    DOCUMENT = "document",
    COMMENT = "comment",
    PAGE='page',
    LoginActivity='login-activity',
    ERROR_LOGS='error-logs',
    SHOW_CONTENT='show-content',
    COLLECTION = 'collection',
    SHOW = 'show',
    COLLECTION_CONTENT = 'collection-content',
    SHOWS = 'shows',
    SHOW_META = 'show-meta',
    SHOW_EPISODE = 'show-episode',
    WIDGET = 'widget',
    WIDGETS_DETAILS = 'widgets-details',
    SUBSCRIPTION_HEADER = 'subscription-header',
    PAYWALL_TEMPLATES = 'paywall-templates',
    ICONS = 'icons',
    AI_PROMPTS = 'ai-prompts',
    PROMPTS = 'prompts',
    DISLIKE_REASON_REPORT = 'dislike-reason-report',
    DISLIKE_EPISODES = 'dislike-episodes',
    RATING_REPORT = 'rating-report',
    DASHBOARD_REPORT = 'dashboard-report',
    VIDEO_TRACKING_REPORT = 'video-tracking-report',
    BUFFER_LOGS = 'buffer-logs',
    VIDEO_PLAYER_ERROR_LOGS = 'video-player-error-logs',
    WEBHOOK_INSTRUMENT = 'webhook-instrument',
    SUBSCRIPTION_REPORT = 'subscription-report',
    USER_PLAN_REPORT = 'user-plan-report',
    PAYMENT_ORDER_REPORT = 'payment-order-report',
    SUBSCRIPTION_HEALTH_STATE_DISTRIBUTION = 'subscription-health-state-distribution',
    SUBSCRIPTION_HEALTH_STATE_CHANGES = 'subscription-health-state-changes',
    SUBSCRIPTION_HEALTH_KPIS = 'subscription-health-kpis',
    VIDEO_TRACKING_APP_VERSIONS = 'video-tracking-app-versions',
    ACQUISITION_REPORT = 'acquisition-report',
    ACQUISITION_FUNNEL_REPORT = 'acquisition-funnel-report',
    REVENUE_MONETIZATION_REPORT = 'revenue-monetization-report',
    SEARCH_CAPSULES = 'search-capsules',
    CONTESTS = 'contests',
    QUESTIONS = 'questions',
    REWARDS = 'rewards',
    TOOLS = 'tools',
    APP_VERSIONS = 'app-versions',
    BUSINESS_RULE = 'business-rule',
    ASK_QUESTION = 'ask-question',
    USER_HISTORY = 'user-history',
    USER_AFFINITY = 'user-affinity',
    USER_PERSONALIZATION = 'user-personalization',
    CUSTOM_CHECKOUT = 'custom-checkout-template-config',
        // Articles
    ARTICLES = 'articles',
    ARTICLE_DETAIL = 'article-detail',
    SERIES_ARTICLE = 'series-article',
    
}
